
  import { defineComponent, PropType } from 'vue';

  import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
  import TableTree from '@/common/components/redesigned/Table/TableTree/TableTree.vue';
  import { TTableTreeColumnConfig, TTableTreeConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { TBaseViewsCountTableItem } from '../../types/statistics/common';
  import StatisticsBaseSwitchTab from './StatisticsBaseSwitchTab.vue';

  export default defineComponent({
    name: 'StatisticsViewsCountByNavigationTab',
    components: {
      TableTree,
      StatisticsBaseSwitchTab,
    },
    props: {
      firstStorePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      secondStorePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      filter: {
        type: Object as PropType<TFilter>,
        required: true,
      },
      viewsCountColumn: {
        type: Object as PropType<TTableTreeColumnConfig<TBaseViewsCountTableItem>>,
        required: false,
        default: () => ({
          field: 'viewsCount',
          title: 'Количество просмотров',
          textAlign: 'right',
          sortable: true,
          width: 210,
        }),
      },
    },
    data(): {
      tableConfig: Omit<TTableTreeConfig<TBaseViewsCountTableItem>, 'storePaths'>;
      firstTitle: string;
      secondTitle: string;
    } {
      return {
        firstTitle: 'По подсистемам',
        secondTitle: 'По страницам',
        tableConfig: {
          columns: [
            {
              field: 'name',
              title: 'Наименование страницы',
              link: {
                callback: (item) => {
                  return item.path;
                },
                isBlank: true,
              },
            },
            this.viewsCountColumn,
          ],
        },
      };
    },
  });
